import React, { Component } from "react";

const Header = (props) => {
    const { video, index, length } = props;
    // console.log(video)
    return (
        <header>
            <div className="row between-xs">
                <div className="video-title">{video.title}</div>
                <div className="flex">
                    <div className="pager">{`${index + 1}/${length}`}</div>
                    <a target="_blank" href={video.source}>
                        🔗
                    </a>
                </div>
            </div>
        </header>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx